import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-secondary/5 py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
      
      <div className="container mx-auto px-6 md:px-8 lg:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="max-w-2xl mx-auto lg:mx-0 text-center lg:text-left">
            <div className="inline-flex items-center justify-center px-4 md:px-6 py-2 md:py-3 bg-primary/10 rounded-full mb-6 md:mb-8">
              <Icon name="Wifi" size={20} color="var(--color-primary)" strokeWidth={2} className="mr-2" />
              <span className="font-body text-sm md:text-base font-medium text-primary">Offline-First POS Solution</span>
            </div>

            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6 md:mb-8 leading-tight">
              Your Business Never Stops,<br className="hidden md:block" /> Even When Internet Does
            </h1>

            <p className="font-body text-base md:text-lg lg:text-xl text-muted-foreground mb-8 md:mb-10 lg:mb-12 leading-relaxed">
              Cultaz Desktop POS ensures uninterrupted retail operations with complete offline functionality. Process transactions, manage inventory, and print receipts without internet dependency. Your data stays local, secure, and always accessible.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 md:gap-6 mb-12 md:mb-16">
              <Button
                asChild
                variant="default"
                size="lg"
                iconName="Download"
                iconPosition="left"
                className="w-full sm:w-auto"
              >
                <Link to="/downloads">Download Desktop POS</Link>
              </Button>
              <Button
                asChild
                variant="outline"
                size="lg"
                iconName="Phone"
                iconPosition="left"
                className="w-full sm:w-auto"
              >
                <Link to="/support">Contact Sales</Link>
              </Button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 max-w-xl mx-auto lg:mx-0">
              <div className="flex flex-col items-center p-4 bg-card rounded-xl border border-border shadow-purple-sm">
                <Icon name="HardDrive" size={28} color="var(--color-primary)" strokeWidth={2} className="mb-2" />
                <h3 className="font-heading text-sm font-semibold text-foreground mb-1">Local Storage</h3>
                <p className="font-body text-xs text-muted-foreground text-center">Complete data control</p>
              </div>

              <div className="flex flex-col items-center p-4 bg-card rounded-xl border border-border shadow-purple-sm">
                <Icon name="Zap" size={28} color="var(--color-primary)" strokeWidth={2} className="mb-2" />
                <h3 className="font-heading text-sm font-semibold text-foreground mb-1">Lightning Fast</h3>
                <p className="font-body text-xs text-muted-foreground text-center">Zero latency</p>
              </div>

              <div className="flex flex-col items-center p-4 bg-card rounded-xl border border-border shadow-purple-sm">
                <Icon name="Shield" size={28} color="var(--color-primary)" strokeWidth={2} className="mb-2" />
                <h3 className="font-heading text-sm font-semibold text-foreground mb-1">Monthly License</h3>
                <p className="font-body text-xs text-muted-foreground text-center">Flexible plans</p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-lg border border-border">
              <img
                src="/cultaz-offline.png"
                alt="Cultaz Desktop POS on laptop"
                className="w-full h-auto aspect-[4/3] object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;